module.exports = function view (state, actions) {
  return h('footer', { class: 'footer' }, h('div', { class: 'container' }, h('div', { class: 'content has-text-centered' }, h('p', {}, [
    h('a', { href: 'http://opensource.org/licenses/mit-license.php' }, 'MIT'),
    '.'
  ]))))
}
